define('home/collections/common/ExtensibleCollection',[
    'jquery',
    'underscore',
    'backbone',

    'core/collections/PaginatedCollection',
], function (
    $,
    _,
    Backbone,

    PaginatedCollection
) {
    'use strict';

    /**
     * A collection that supplements the thread portion of its contents
     * with additional data from embedly.
     */
    var ExtensibleCollection = PaginatedCollection.extend({
        // Override the default value, 30 since activity endpoints are slow
        PER_PAGE: 10,

        initialize: function () {
            PaginatedCollection.prototype.initialize.call(this, arguments);

            this.once('sync', this.extendData, this);
            this.on('add:many', this.extendData, this);
            this.on('nodata', this.onNoData, this);
        },

        /**
         * Called when an extensible collection is first fetched, when a set of models
         * are added to an extensible colleciton, or when a model in an extensible
         * collection has been fetched.
         * Because of these different triggers, data may be a collection, an array
         * of models, or a single model.
         */
        extendData: function (data) {
            var models;
            if (data.models) {
                models = data.models;
            } else if (data instanceof Backbone.Model) {
                models = [data];

                // This case occurs when a single model in this collection is fetched.
                // Need to rebind the sync listener for future fetches.
                this.once('sync', this.extendData, this);
            } else {
                models = data;
            }

            if (!models.length) {
                // Thought there was more items available but they were
                // probably filtered before being returned.
                this.cursor.hasNext = false;
                this.trigger('nodata');
                return;
            }

            // track amount of data we received
            /* TODO: check if thread is already subsidize, now that we're using unique models,
             * a lot of threads are duplicates */
            var from = 0;
            this.extensionRequestsCount = 0;
            do {
                var to = Math.min(from + 10, models.length);
                var subset = models.slice(from, to);

                this.requestExData(subset);
                from += 10;
                this.extensionRequestsCount += 1;
            } while (from <= models.length - 1);
        },

        getThreadFromModel: function (model) {
            if (!model.getThread)
                throw new Error('Any model that is in an ExtensibleCollection must define function getThread');

            return model.getThread();
        },

        // Subsidizes existing feed item models with data from embedly.
        // This typically includes an image and a snippet from the thread
        // stored in the feed item, to be used as the thread preview.
        requestExData: function (models, attempts) {
            attempts = attempts || 0;

            var modelsByUrl = {};
            _.each(models, function (model) {
                var thread = this.getThreadFromModel(model);
                var links = thread && thread.getLinks() || [];

                // If thread contains multiple links, don't choose any of them
                var url = links.length === 1 ? links[0] : null;

                if (!this.shouldExtend(thread, url)) {
                    if (thread)
                        thread.set({ extending: false });
                    return;
                }

                thread.set({ extending: true });
                modelsByUrl[url] = model;
            }, this);

            var urls = _.keys(modelsByUrl);
            // Bail out if no threads or urls to extend
            if (!urls.length)
                return;

            var params = {
                url: urls,
                words: 200,
                image_width: 320,
            };

            $.ajax({
                url: ExtensibleCollection.EXTRACT_URL,
                data: params,
                traditional: true,
                dataType: 'jsonp',
                success: function (response) {
                    models.timeouts = 0;
                    this.onExtendData(response, modelsByUrl);
                },
                error: function (response) {
                    this.extendDataFailed(response, models, attempts);
                },
                context: this,
                timeout: 3000,
                complete: this.checkExtendDataComplete,
            });
        },

        shouldExtend: function (thread, url) {
            // Don't bother hitting embedly for urls in rich media. They'll be
            // fetched when the media is rendered.
            return thread && url && !_.any(thread.getMedia(), function (media) {
                return media.url === url;
            });
        },

        onExtendData: function (response, modelsByUrl) {
            this.extensionRequestsCount -= 1;
            _.each(response, function (item) {
                // IE sometimes gets an `undefined` or `null` `item` here
                // so first check that and then try to get the model
                var model = item && modelsByUrl[item.original_url];
                if (!model)
                    return;

                var thread = this.getThreadFromModel(model);

                thread.setEmbedlyData(item);
                thread.set({ extending: false });
            }, this);
        },

        extendDataFailed: function (response, models, attempts) {
            // Try request 3 times if timeout
            if (response.statusText === 'timeout' && attempts < 3) {
                this.handleTimeout(models, attempts);
                return;
            }

            _.each(models, function (model) {
                var thread = this.getThreadFromModel(model);
                thread.set({ extending: false });
            }, this);
            this.extensionRequestsCount -= 1;
        },

        handleTimeout: function (models, attempts) {
            this.requestExData(models, attempts + 1);
        },

        checkExtendDataComplete: function () {
            if (this.extensionRequestsCount)  // wait for more responses
                return;

            this.finalizeExtendingData(this.cursor.hasNext);
        },

        finalizeExtendingData: function (hasNext) {
            this.trigger('extend', hasNext);
        },

        onNoData: function () {
            this.finalizeExtendingData();
        },
    }, {
        EXTRACT_URL: '//extract.services.disqus.com',
    });

    return ExtensibleCollection;
});

